import React from "react"
import { Tractor } from "../../../images"
import { useState, useEffect } from "react"
import { Input } from "@fourkites/elemental-input"
import BottomBar from "../../BottomBar/bottombar"
import AlertIcon from "components/AlertIcon/alertIcon"
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight"
import { useHistory, useLocation } from "react-router"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "store/store"
import { useTranslation } from "react-i18next"

const GateLinkTractor = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()
  const [disabledProceed, setdisabledProceed] = useState(true)
  const [disabledPhone, setdisabledPhone] = useState(false)
  const [TractorNumber, setTractorNumber] = useState("")
  const [invalidTractorNumber, setinvalidTractorNumber] = useState(false)

  const assetReducer = useSelector((state: RootState) => state.assetReducer)
  const setAssetsDetails = () => {
    let asset = {
      ...assetReducer.asset,
      tractor: TractorNumber
    }

    dispatch({
      type: "SET_ASSET_INFO",
      payload: asset
    })

    history.push("/trailer-info")
  }
  const handlePaste = (limit: number) => {
    let truncatTractorNumber = TractorNumber.substring(0, limit)
    setTractorNumber(truncatTractorNumber)
  }
  useEffect(() => {
    if (TractorNumber.trim().length > 0) {
      setdisabledProceed(false)
    } else {
      setdisabledProceed(true)
    }
  }, [TractorNumber])

  const tractor_not_valid = t("tractor_not_valid")

  return (
    <>
      <div className="truck-container">
        <div className="truck-header-text ">{t("enter_tractor_number")}</div>
        <div
          className={`driver-input driver-input-USDOT-font ${
            invalidTractorNumber ? "error-label" : ""
          }`}
        >
          <Input
            autoFocus={true}
            className={`${invalidTractorNumber ? "error-label" : ""}`}
            placeholder={t("enter_tractor_here")}
            label=""
            value={TractorNumber}
            maxLength={20}
            disabled={disabledPhone}
            hideLabel={false}
            invalid={invalidTractorNumber}
            onChange={event => setTractorNumber(event.target.value)}
            onPaste={e => handlePaste(20)}
            errorLabel={invalidTractorNumber ? tractor_not_valid : ""}
            icon={
              invalidTractorNumber ? (
                <AlertIcon className="elemental-Input-icon--invalid" />
              ) : (
                <></>
              )
            }
          />
        </div>
        <img src={Tractor} />
        <div className="info"></div>
      </div>
      <BottomBar
        disabled={disabledProceed}
        onClick={() => setAssetsDetails()}
        text={t("save_and_proceed")}
        endIcon={<KeyboardArrowRightIcon />}
      />
    </>
  )
}

export default GateLinkTractor
